<template>
  <div class="subpage-dashboards subpage-dashboard--dashboard">
    <h1 class="my-account__title gds-space-stack-l">
      My Account Dashboard
    </h1>
    <section class="my-account__card-section gds-flex-container gds-flex-container--top gds-flex-container--wrap">
      <card-account-profile></card-account-profile>
      <card-report-issue></card-report-issue>
      <card-pay-bill></card-pay-bill>
      <card-latest-bill></card-latest-bill>
      <card-recent-transactions></card-recent-transactions>
      <card-usage></card-usage>
      <card-outages-near-you></card-outages-near-you>
    </section>
  </div>
</template>

<script>
import CardAccountProfile from "./CardAccountProfile";
import CardReportIssue from "../../CardReportIssue";
import CardPayBill from "../../CardPayBill";
import CardLatestBill from "./CardLatestBill";
import CardRecentTransactions from "./CardRecentTransactions";
import CardUsage from "./CardUsage";
import CardOutagesNearYou from "./CardOutagesNearYou";

export default {
  name: "SubpageDashboard",
  components: {
    CardAccountProfile,
    CardReportIssue,
    CardPayBill,
    CardLatestBill,
    CardRecentTransactions,
    CardUsage,
    CardOutagesNearYou,
  },
  data() {
    return {
    };
  },
  computed: {
  },
  async mounted() {
  },
  methods: {
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>